import { useEffect, useState } from 'react';
import { IInputStatus } from '../../../interface/progress.interface';

interface Props {
  value: string;
  status: IInputStatus
  focused: boolean
  progressTrigger?: Function
}

const changeStatusArr = [IInputStatus.apiError, IInputStatus.error, IInputStatus.success]
const invalidValue = ['', undefined]

const useLocalStatus = ({ value, status, focused, progressTrigger }: Props) => {
  const [localStatus, setLocalStatus] = useState<IInputStatus>(IInputStatus.none);

  useEffect(() => {
    console.log('useLocalStatus useEffect', status, focused)
    if (!focused && changeStatusArr.includes(status)) {
      setLocalStatus(status)
      if (progressTrigger) {
        progressTrigger()
      }
    }
    // if (
    //   !focused &&
    //   (status === IInputStatus.apiError
    //   || status === IInputStatus.error)
    // ) {
    //   setLocalStatus(status)
    //   if (progressTrigger) {
    //     progressTrigger()
    //   }
    // } else if ( status === IInputStatus.success && !focused) {
    //   setLocalStatus(IInputStatus.success)
    //   if (progressTrigger) {
    //     progressTrigger()
    //   }
    // } else {
    //   // setLocalStatus(status)
    // }
  }, [status, value])

  
  const changeStatusHandler = () => {
    console.log('changeStatusHandler', value, status)
    if (!invalidValue.includes(value) && changeStatusArr.includes(status)) {
      setLocalStatus(status)
    } else {
      setLocalStatus(IInputStatus.none)
    }

    // if (value !== '' && (status === IInputStatus.apiError || status === IInputStatus.error)) {
    //   setLocalStatus(status)
    // } else if (value !== '' && status === IInputStatus.success) {
    //   setLocalStatus(IInputStatus.success)
    // } else {
    //   setLocalStatus(IInputStatus.none)
    // }
  }

  const setChangeStatusHandler = () => {
    setLocalStatus(IInputStatus.change);
  }

  return {
    localStatus,
    changeStatusHandler,
    setChangeStatusHandler
  }
}

export default useLocalStatus;